// extracted by mini-css-extract-plugin
export var cardLayout = "_7n-1";
export var paginationContainer = "_7n-0";